import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-background" data-testid="site-footer">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 sm:flex-row sm:px-6 lg:px-8">
        <div className="flex items-center gap-3">
          <Logo to={null} />
          <span className="hidden text-sm text-muted-foreground sm:inline">Escolha → Ative → Pronto.</span>
        </div>
        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} VULPIX — Ativações de Aplicativos.
        </p>
      </div>
    </footer>
  );
}
